import Breadcrumb from '@/src/components/Antd/Breadcrumb/Breadcrumb';
import React from 'react';
import { useHistory, useParams } from 'react-router';
import { handleClick } from 'src/constrains/CreateButtonWithLanguageChangeWarning/tools';
import { useI18n } from 'src/hooks/useRouterChange';
import ListPageLayout from 'src/layout/ListPageLayout/ListPageLayout';
import { NEW } from 'src/tools/constant';
import { i18nGet } from 'src/tools/tools';
import { EStatus } from 'src/types/common/promotionTag';
import ActiveTable from './ActiveTable';
import ExpiredTable from './ExpireTable';
import css from './css.module.less';

import {
  isUserValid,
  salesChannelResourceNameGenerator,
} from 'src/tools/getUserInfo';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from 'src/types/common/resources';
import { SalesChannelModeAccessControlHOC } from 'src/constrains/SalesChannelModeAccessControl';

const permissions = (saleChannelUuid) => {
  const canViewListing = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        uuid: saleChannelUuid,
        category: EnumCategory.SalesChannelProduct,
        subCategory: EnumSubCategory.ChannelProduct,
        operation: EnumOperation.view_all_promotion_tags_listing_page,
      }),
    ],
  });
  const canViewDetails = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        uuid: saleChannelUuid,
        category: EnumCategory.SalesChannelProduct,
        subCategory: EnumSubCategory.ChannelProduct,
        operation: EnumOperation.view_promotion_tag_details_page,
      }),
    ],
  });
  const canCreate = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        uuid: saleChannelUuid,
        category: EnumCategory.SalesChannelProduct,
        subCategory: EnumSubCategory.ChannelProduct,
        operation: EnumOperation.add_edit_promotion_tag,
      }),
    ],
  });
  const canDelete = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        uuid: saleChannelUuid,
        category: EnumCategory.SalesChannelProduct,
        subCategory: EnumSubCategory.ChannelProduct,
        operation: EnumOperation.delete_promotion_tag,
      }),
    ],
  });
  return { canViewListing, canViewDetails, canCreate, canDelete };
};

const PromotionTagList = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const h = useHistory();
  const { uuid: salesChannelUuid }: any = useParams();
  const [index, setIndex] = React.useState(0);
  //const { uuid: salesChannelUuid }: any = useParams();
  const [selectTab, setSelectedTab] = React.useState('');

  const userPermissions = permissions(salesChannelUuid);

  const handleOnTabChange = (tab) => {
    setSelectedTab(tab);
    return;
  };

  const pageLayoutProps = {
    title: getI18n('salesChannelPromotionTag.index.promotionTags'),
    //tabBarStyle: { padding: 16 },
    containerClassName: css.tabContainer,
    // addButtonOverlay,
    addText:
      userPermissions.canCreate &&
      getI18n('salesChannelPromotionTag.index.addPromotionTag'),
    // exportFun,
    //importFun,
    addFun: () => {
      handleClick({
        onClick: () => {
          h.push(
            `/salesChannel/promotionTag/editor/${salesChannelUuid}/${NEW}?defaultName=Promotion Tag ${
              index + 1
            }`,
          );
        },
        title: getI18n('salesChannelPromotionTag.index.addPromotionTag'),
        content: getI18n(
          'salesChannelPromotionTag.index.addPromotionTagContent',
        ),
        onOkText: getI18n('general.antd.Uploader.ok'),
        onCancelText: getI18n('general.cancel'),
        salesChannelUuid,
      });
    },
    tabChange: handleOnTabChange,
    activeKey: selectTab,
    tabsConfig: [
      //定义tabs列表
      {
        name: getI18n('salesChannelPromotionTag.index.activeScheduled'),
        key: '',
      },
      { name: getI18n('general.status.expired'), key: EStatus.Expired },
    ],
    noPermission: !userPermissions.canViewListing,
  };
  return (
    <React.Fragment>
      <Breadcrumb
        className={css.breadcrumb}
        breadcrumbData={[
          {
            url: '/',
            name: getI18n('general.sider.home'),
          },
          {
            url: '',
            name: getI18n('salesChannelPromotionTag.index.promotionTags'),
          },
        ]}
      />
      <ListPageLayout {...pageLayoutProps}>
        {selectTab ? (
          <ExpiredTable userPermissions={userPermissions} />
        ) : (
          <ActiveTable setIndex={setIndex} userPermissions={userPermissions} />
        )}
      </ListPageLayout>
    </React.Fragment>
  );
};

export default SalesChannelModeAccessControlHOC(PromotionTagList);
